import React from 'react'
import "./Rewards_banner.css"
import Current_rank_main_card_lottie from '../../../animations/current_rank_main_card_lottie/Current_rank_main_card_lottie'
import { Link } from 'react-router-dom'

function Rewards_banner() {
    return (
        <>
            <section className='Rewards_banner'>
                <div className="Rewards_banner_holder">
                    <div className="banner_img_holder">
                        <img src="/assets/images/profile/rewards/rewards_banner/bg.png" alt="" className='banner_img' />
                    </div>

                    <div className="banner_text_holder">
                        <h5>MY REWARDS: A CHANCE TO WIN EXCITING REWARDS!</h5>
                    </div>



                    <div className="Current_rank_main_card_lottie_holder">
                        <Current_rank_main_card_lottie />
                        <Current_rank_main_card_lottie />
                        <Current_rank_main_card_lottie />
                    </div>
                </div>
                <div className="view_all_btn_holder">
                    <h6>My Rewards</h6>
                    <Link to={"/my-rewards"}>
                        <p>View All</p>
                    </Link>
                </div>
            </section>



        </>
    )
}

export default Rewards_banner